import { useQuery } from 'data-fetching-client';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedList from 'I18n/components/FormattedList';
import EmailName from 'automation-ui-references/customer-data/EmailName';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
import { CONTACT_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { useAssociationDefinitions } from 'automation-ui-associations/hooks/associationDefinitionsHooks';
import getAssociationLabel from 'automation-ui-associations/utils/getAssociationLabel';
import findAssociationDefinitionFromSpec from 'automation-ui-associations/utils/findAssociationDefinitionFromSpec';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EmailActionSummary({
  metadata: {
    contentId,
    recipients
  },
  flowObjectTypeId
}) {
  const {
    data: {
      objectTypeById: targetObjectTypeDefinition = undefined
    } = {}
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    variables: {
      objectTypeId: CONTACT_ID
    }
  });
  const associationDefinitionsQuery = useAssociationDefinitions([flowObjectTypeId]);
  const emailName = /*#__PURE__*/_jsx(EmailName, {
    id: contentId
  });
  if (recipients.size) {
    const associationLabels = targetObjectTypeDefinition ? /*#__PURE__*/_jsx(FormattedList, {
      children: recipients.toArray().map((recipient, index) => /*#__PURE__*/_jsx("strong", {
        children: getAssociationLabel({
          associationDefinition: findAssociationDefinitionFromSpec(recipient.get('associationSpec'), associationDefinitionsQuery),
          toObjectTypeDefinition: targetObjectTypeDefinition
        })
      }, index))
    }) : /*#__PURE__*/_jsx(SkeletonText, {});
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.email.summary.associatedContacts",
      options: {
        emailName,
        associationLabels
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.email.summary.enrolledContact",
      options: {
        emailName
      }
    });
  }
}